<template>
    <!-- main header start -->
    <div class="pa-main-header">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4">
                    <div class="pa-logo">
                        <a href="/"><img src="../assets/images/logo-hg.svg" alt="logo" class="img-fluid"/></a>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="pa-nav-bar">
                        <div class="pa-menu">
                            <ul>
                                <li><a href="javascript:;" :class="{'hide': myHide}" @click="$emit('redirect')">{{goto}}</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- main header end -->
</template>

<script>
export default {
  name: 'Header',
  props: ['goto', 'myHide'],
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hide {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue